import { Address, WalletKey } from "@silo/types";
import { cn } from "../../utils/class-names";
import { Button, getButtonClassNames } from "../button";
import { AccountBadge, AccountBadgeState } from "./account-badge";
import { tv } from "tailwind-variants";
import { ReactNode } from "react";

export const connectedTrigger = tv({
  base: cn(
    getButtonClassNames("tertiary", "normal"),
    "py-[3px] px-2.5 group sm:w-fit"
  ),
});

export interface ConnectedTriggerProps extends ConnectedTriggerContentProps {
  className?: string;
  onClick: () => void;
}

export function ConnectedTrigger({
  className,
  onClick,
  ...rest
}: ConnectedTriggerProps): JSX.Element {
  return (
    <Button
      onClick={onClick}
      variant="tertiary"
      className={connectedTrigger()}
      data-cy="wallet-info-button"
    >
      <ConnectedTriggerContent {...rest} />
    </Button>
  );
}

interface ConnectedTriggerContentProps {
  className?: string;
  account: Address;
  state: AccountBadgeState;
  ensName: string | undefined;
  isImpersonating: boolean;
  walletKey: WalletKey;
  chevron: ReactNode;
}

export function ConnectedTriggerContent({
  className,
  account,
  state,
  ensName,
  isImpersonating,
  walletKey,
  chevron,
}: ConnectedTriggerContentProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <AccountBadge
        account={account}
        ensName={ensName}
        state={state}
        isImpersonating={isImpersonating}
        walletKey={walletKey}
      />

      {chevron}
    </div>
  );
}
